import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import CButton from '@/components/shared/CButton';
import CInput from '@/components/shared/CInput';
import type { ImagePlaceholderElement } from '@/typings/customilyElements/canvasElements';
import { isTextToImageEffect } from '@/typings/customilyElements/imageEffectType';

interface Props {
    imageElement: ImagePlaceholderElement;
    alwaysStacked?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEffectsTestPrompt',
  props: {
    imageElement: null,
    alwaysStacked: { type: Boolean }
  },
  emits: ["is-text-to-image-effect", "generate-prompt"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'is-text-to-image-effect', value: boolean): void;
    (event: 'generate-prompt', prompt: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    imageElement: ImagePlaceholderElement;
    alwaysStacked?: boolean;
};





const prompt = ref('');

const isTextToImage = computed(() => {
    const type = props.imageElement?.imageEffects?.[0]?.type;
    if (!type) return false;
    return isTextToImageEffect(type);
});

watch(isTextToImage, (value) => emit('is-text-to-image-effect', value), { immediate: true });

const handleGenerate = () => {
    const trimmedPrompt = prompt.value.trim();
    if (!trimmedPrompt) return;

    emit('generate-prompt', trimmedPrompt);
};

return { __sfc: true,props, emit, prompt, isTextToImage, handleGenerate, CButton, CInput }
}

})